"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@dbi-tools/ui-kit");

var _heroSlide = require("../../hero-slide.styled");

var _buttons = _interopRequireDefault(require("../buttons"));

var _textImage = _interopRequireDefault(require("../text-image"));

var _heroSlideA = require("./hero-slide-a.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeroSlideA = function HeroSlideA(_ref) {
  var line1 = _ref.lineOneText,
      line2 = _ref.lineTwoText,
      line3 = _ref.lineThreeText,
      line4 = _ref.lineFourText,
      line5 = _ref.lineFiveText,
      type = _ref.textType,
      images = _ref.textAsImages,
      buttons = _ref.buttons,
      position = _ref.contentPosition,
      bg = _ref.textBackgroundColor;
  return /*#__PURE__*/_react.default.createElement(_heroSlideA.Wrap, null, /*#__PURE__*/_react.default.createElement(_uiKit.Container, null, /*#__PURE__*/_react.default.createElement(_heroSlideA.SlideContainer, {
    position: position
  }, /*#__PURE__*/_react.default.createElement(_heroSlideA.HeroSlideBlock, {
    bg: bg
  }, /*#__PURE__*/_react.default.createElement(_heroSlideA.Content, null, type === 'type_text' ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, line1 && /*#__PURE__*/_react.default.createElement(_heroSlideA.Line1Wrap, null, /*#__PURE__*/_react.default.createElement(_heroSlide.Line1, {
    as: "h5"
  }, line1)), line2 && /*#__PURE__*/_react.default.createElement(_heroSlide.Line2, {
    as: "h4"
  }, line2), line3 && /*#__PURE__*/_react.default.createElement(_heroSlide.Line3, {
    as: "h2"
  }, line3), line4 && /*#__PURE__*/_react.default.createElement(_heroSlide.Line4, {
    as: "h2"
  }, line4), line5 && /*#__PURE__*/_react.default.createElement(_heroSlide.Line5, {
    as: "h3"
  }, line5)) : /*#__PURE__*/_react.default.createElement(_textImage.default, {
    images: images
  })), /*#__PURE__*/_react.default.createElement(_buttons.default, {
    color: bg,
    buttons: buttons
  })))));
};

var _default = HeroSlideA;
exports.default = _default;